/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import SavedReplyConstants from 'constants/SavedReplyConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const SavedReplyQueries = Marty.createQueries({
  id: 'SavedReplyQueries',

  fetchReplies() {
    const promise = this.app.sources.SavedReplyAPI.fetchReplies()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(SavedReplyConstants.REPLY_LIST_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(SavedReplyConstants.REPLY_LIST_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SavedReplyConstants.REPLY_LIST_FETCH_FAILED, error)
    })
  },

  fetchReply(replyId) {
    const promise = this.app.sources.SavedReplyAPI.fetchReply(replyId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(SavedReplyConstants.REPLY_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(SavedReplyConstants.REPLY_FETCH_FAILED, replyId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SavedReplyConstants.REPLY_FETCH_FAILED, replyId, error)
    })
  },

  createReply(reply) {
    this.dispatch(SavedReplyConstants.CREATE_REPLY_STARTING, reply)
    const promise = this.app.sources.SavedReplyAPI.createReply(reply)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(SavedReplyConstants.CREATE_REPLY_DONE, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `${ res.body.name } has been saved!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(SavedReplyConstants.CREATE_REPLY_FAILED, reply, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SavedReplyConstants.CREATE_REPLY_FAILED, reply, error)
    })
  },

  updateReply(replyId, reply, notify) {
    this.dispatch(SavedReplyConstants.UPDATE_REPLY_STARTING, replyId, reply)
    const promise = this.app.sources.SavedReplyAPI.updateReply(replyId, reply)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(SavedReplyConstants.UPDATE_REPLY_DONE, res.body)
        if (notify) {
          let finishedAction, variant
          if (reply.status !== 'ARCHIVED') {
            finishedAction = 'updated'
            variant = 'green'
          } else {
            finishedAction = 'deleted'
            variant = 'green'
          }
          return this.app.actions.NotificationActions.pushNotification({
            content: `${ res.body.name } has been ${ finishedAction }!`,
            variant
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(SavedReplyConstants.UPDATE_REPLY_FAILED, replyId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SavedReplyConstants.UPDATE_REPLY_FAILED, replyId, error)
    })
  }
})

export default SavedReplyQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/SavedReplyQueries.js